<template>
  <div v-if="order.actions">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <v-tooltip
        top
        v-if="
          showView &&
          ($permission.permissionAllow('Orders', 'index') ||
            $permission.permissionAllow('Orders', 'approval'))
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            :href="
              ($route.path.startsWith('/orders-approve')
                ? '/#/orders-approve/'
                : '/#/orders/') + order.id
            "
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("Opt.details") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.viewInfo", [$t("Order.ObjectName")]) }}</span>
      </v-tooltip>
      <!-- 导出订单 -->
      <v-tooltip
        top
        v-if="
          showExport && $permission.permissionAllow('Orders', 'detailExport')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click.stop="orderExport()"
          >
            <v-icon x-small class="pe-1">fa-file-excel</v-icon>
            {{ $t("Order.actions.export") }}
          </v-btn>
        </template>
        <span>{{ $t("Order.actions.export") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showEdit &&
          $permission.permissionAllow('Orders', 'view')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="detailMode
              ? $emit('edit')
              : $router.push(($route.path.startsWith('/orders-approve') ? '/orders-approve/' : '/orders/') + order.id + '/edit');
            "
          >
            <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
            {{ $t("Order.actions.edit") }}
          </v-btn>
        </template>
        <span>{{ $t("Order.actions.editOrder") }}</span>
      </v-tooltip>
    </v-sheet>
  </div>
</template>

<script>

export default {
  name: "OrderActions",

  components: {
  },

  props: {
    order: Object,
    detailMode: Boolean,
    showView: Boolean,
    showEdit: Boolean,
    showExport: Boolean,
  },

  computed: {},

  data: () => ({}),

  methods: {

  },
  watch: {
  },
};
</script>